import React, { useState, useEffect } from 'react';
import Order from '../Order';
import { onUpdateOrder as OnUpdateOrder } from "../../graphql/subscriptions";
import { listOrders as ListOrders } from "../../graphql/queries";
import { API, graphqlOperation } from "@aws-amplify/api";
import { Wrapper } from './styles';

const statuses = [
    { status: { eq: "confirmed" } },
    { status: { eq: "processed" } },
    { status: { eq: "refund" } }
];

const PAID = 'paid';
const CONFIRMED = 'confirmed';
const LIMIT = 1000;

// Get start of day
const startOfDay = new Date();
startOfDay.setHours(0, 0, 0, 0);

// Get end of day
const endOfDay = new Date();
endOfDay.setHours(23, 59, 59, 999);

const Orders = ({ accountId }) => {
    const [orders, setOrders] = useState([]);

    const subscribeToOrderUpdates = () => {
        const variables = {
            filter: {
                accountId: {
                    eq: accountId,
                },
                or: statuses,
                updatedAt: { between: [startOfDay.toISOString(), endOfDay.toISOString()] },
                paymentStatus: {
                    eq: PAID
                }
            }
        }
        const subscription = API.graphql(
            graphqlOperation(OnUpdateOrder, variables)
        ).subscribe({
            next: (orderData) => {
                setOrders(prevOrders => {
                    const findIndex = prevOrders.findIndex(order => order.id === orderData.value.data.onUpdateOrder.id);
                    if (findIndex > -1) {
                        prevOrders[findIndex] = orderData.value.data.onUpdateOrder;
                    } else {
                        prevOrders.push(orderData.value.data.onUpdateOrder);
                    }

                    const uniqueOrders = new Set([...prevOrders]);
                    const unprocessedOrders = Array.from(uniqueOrders).filter(order => order.status === CONFIRMED);

                    return sortOrdersByCreatedAt(unprocessedOrders);
                });
            },
            error: (error) => console.warn(error),
        });

        return subscription;
    };

    const sortOrdersByCreatedAt = (ordersToSort) => {
        return ordersToSort.sort((a, b) => {
            const dateA = new Date(a.updatedAt);
            const dateB = new Date(b.updatedAt);
            return dateA - dateB;
        });
    }
    const fetchOrders = async () => {
        const variables = {
            filter: {
                accountId: {
                    eq: accountId,
                },
                status: { eq: CONFIRMED },
                updatedAt: { between: [startOfDay.toISOString(), endOfDay.toISOString()] },
                paymentStatus: {
                    eq: PAID
                }
            },
            limit: LIMIT
        }
        const orderData = await API.graphql(
            graphqlOperation(ListOrders, variables)
        ).catch((error) => console.log(error));
        setOrders([]);
        setOrders(sortOrdersByCreatedAt(orderData.data.listOrders.items));
    };


    useEffect(() => {
        let subscription = subscribeToOrderUpdates();

        const handleNetworkChange = () => {
            if (navigator.onLine) {
                subscription = subscribeToOrderUpdates();
                fetchOrders();
            } else {
                subscription.unsubscribe();
            }
        };

        window.addEventListener('online', handleNetworkChange);
        window.addEventListener('offline', handleNetworkChange);

        return () => {
            subscription.unsubscribe();
            window.removeEventListener('online', handleNetworkChange);
            window.removeEventListener('offline', handleNetworkChange);
        };
    }, []);

    useEffect(() => {
        fetchOrders();
    }, []);

    return (
        <Wrapper>
            {orders.map(order => (
                <Order key={order.id} order={order} />
            ))}
        </Wrapper>
    );
};

export default Orders;